import { render, staticRenderFns } from "./MetricaPath.vue?vue&type=template&id=3c1b9bd4&scoped=true"
import script from "./MetricaPath.vue?vue&type=script&lang=js"
export * from "./MetricaPath.vue?vue&type=script&lang=js"
import style0 from "./MetricaPath.vue?vue&type=style&index=0&id=3c1b9bd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b9bd4",
  null
  
)

export default component.exports